import axios from 'axios'

class BookletsService {
  getBooklets = ({ page, size }) =>
    axios({
      url: 'booklet',
      method: 'GET',
      params: {
        page,
        take: size,
      },
    })

  getBookletById = (id) =>
    axios({
      url: `booklet/${id}`,
      method: 'GET',
    })

  getBookletTransactionGroups = ({ bookletId, page, size, customerCode, skuCode }) =>
    axios({
      url: `booklet/${bookletId}/transactions/groups`,
      method: 'GET',
      params: {
        page,
        take: size,
        customerCode,
        skuCode,
      },
    })

  getBookletTransactions = ({
    bookletId,
    page,
    size,
    userId,
    customerCode,
    skuCode,
    typeFilter,
    validFromStart,
    validFromEnd,
    validToStart,
    validToEnd,
    redeemAtStart,
    redeemAtEnd,
    serialNumber,
  }) =>
    axios({
      url: `booklet/${bookletId}/transactions`,
      method: 'GET',
      params: {
        page,
        take: size,
        userId,
        customerCode,
        skuCode,
        typeFilter,
        validFromStart,
        validFromEnd,
        validToStart,
        validToEnd,
        redeemAtStart,
        redeemAtEnd,
        serialNumber,
      },
    })

  createBooklet = (data) =>
    axios({
      url: 'booklet',
      method: 'POST',
      data,
    })

  updateBooklet = ({ id, data }) =>
    axios({
      url: `booklet/${id}`,
      method: 'PUT',
      data,
    })

  exportBooklets = ({ startDate, finishDate }) =>
    axios({
      url: 'booklet/export',
      method: 'GET',
      params: {
        startDate,
        finishDate,
      },
      responseType: 'blob',
    })
}

export default new BookletsService()
